import React, { useEffect } from "react";

import { styled } from "@mui/material/styles";

import useUser from "../../../hooks/useUser";
import { useNavigate, useSearchParams } from "react-router-dom";
import { CircularProgress, Box } from "@mui/material";

import NormalUser from "./NormalUser";
import HotelUser from "./HotelUser";

const currentPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [
    {
      field: "createdAt",
      sort: "DESC",
    },
  ],
};

const Img = styled("img")({
  margin: "auto",
  display: "block",
  maxWidth: "100%",
  maxHeight: "100%",
});

const useTabStyles = styled({
  root: {
    justifyContent: "center",
    width: "1000px",
  },
  scroller: {
    flexGrow: "0",
  },
});

function UserDetails(props) {
  console.log(props, "useeeeeeeeeeeeeeeeeeeee");
  const classes = useTabStyles();
  let [searchParams, setSearchParams] = useSearchParams();
  const { getUser, user, isGetUserLoading } = useUser();

  console.log("isGetUserLoading", isGetUserLoading);

  console.log(user, "useruseruser");

  const userId = searchParams.get("id");

  useEffect(() => {
    if (userId) {
      getUser(userId);
    }
  }, [userId]);

  return (
    <React.Fragment>
      {isGetUserLoading ? (
        <Box display="flex" justifyContent="center" my={6}>
          <CircularProgress />
        </Box>
      ) : user && user.userType === "HOTEL_USER" ? (
        <HotelUser />
      ) : user ? (
        <NormalUser permissionKeys={props?.permissions?.permissionKeys} />
      ) : null}
    </React.Fragment>
  );
}

export default UserDetails;
